import React, { useContext, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import { useTranslation } from "react-i18next";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import SelectInputProfile from "./add-inputs-step/SelectInputProfile";
import CreateInputProfile from "./add-inputs-step/CreateInputProfile";
import { ForwarderWizardContext } from "./ForwarderWizardProvider";
import { ForwardersActions } from "../stores/ForwardersStore";
const AddInputsStep = ({ onStepComplete }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { selectedForwarder, setSelectedForwarder, setSelectedInputProfile } = useContext(ForwarderWizardContext);
  const [action, setAction] = useState("select");
  const sendTelemetry = useSendTelemetry("input-profile");
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, t("add_inputs_step.select_forwarder_first"));
  }
  const handleInputProfileSelect = (inputProfile) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_INPUT_PROFILE_SELECTED, {
      app_pathname: "forwarder"
    });
    const updatedForwarder = cloneDeep(selectedForwarder);
    updatedForwarder.input_profile_id = inputProfile.id;
    ForwardersActions.update(selectedForwarder.id, updatedForwarder).then((forwarder) => {
      setSelectedForwarder(forwarder);
      setSelectedInputProfile(inputProfile);
      onStepComplete();
    });
  };
  if (action === "create") {
    return /* @__PURE__ */ React.createElement(CreateInputProfile, { onCancel: () => setAction("select"), onInputProfileCreated: handleInputProfileSelect });
  }
  return /* @__PURE__ */ React.createElement(
    SelectInputProfile,
    {
      onInputProfileSelect: handleInputProfileSelect,
      onCreateInputProfileClick: () => setAction("create")
    }
  );
};
export default AddInputsStep;
